// extracted by mini-css-extract-plugin
module.exports = {"container":"SavedPrice_container__NG42E"};